import { isExperimentEnabled } from '@atlaskit/platform-feature-experiments/is-experiment-enabled';
import type {
	AssistanceServiceProduct,
	SendMessageBrowserContext,
} from '@atlassian/conversation-assistant-service-api/types/assistance-service';

type BrowserContextSanitizer = {
	isBlocklisted: (url: string) => boolean;
};

type ResolveMessageStreamBrowserUrlParams = {
	browserContext?: SendMessageBrowserContext;
	browserContextSanitizer?: BrowserContextSanitizer;
	product?: AssistanceServiceProduct;
};

const getMessageStreamHref = (product?: string): string | undefined => {
	const backendOriginHost = window?.__backendOriginHost;
	if (
		product === 'confluence' &&
		window.location.hostname === 'localhost' &&
		typeof backendOriginHost === 'string'
	) {
		const urlWithLocalhost = new URL(window.location.href);
		urlWithLocalhost.hostname = backendOriginHost;
		urlWithLocalhost.port = '';
		urlWithLocalhost.protocol = 'https:';
		return urlWithLocalhost.toString();
	}
	return window?.location?.href;
};

export const resolveMessageStreamBrowserUrl = ({
	browserContext,
	browserContextSanitizer,
	product,
}: ResolveMessageStreamBrowserUrlParams): {
	browserUrl: string;
	isBrowserContextBlocklisted: boolean;
} => {
	const browserContextUrl = browserContext?.context?.browserUrl;
	const isBrowserContextBlocklisted = Boolean(
		browserContextUrl && browserContextSanitizer?.isBlocklisted(browserContextUrl),
	);
	const isBrowserUrlSuppressed =
		browserContextUrl === 'NO-URL' && isExperimentEnabled('jira_free_gen_editor');

	if (isBrowserContextBlocklisted || isBrowserUrlSuppressed) {
		return { browserUrl: '', isBrowserContextBlocklisted };
	}

	return {
		browserUrl: browserContextUrl || getMessageStreamHref(product) || '',
		isBrowserContextBlocklisted,
	};
};
